<template>
    <div class="hover-green" @click="$bvModal.show('seal-modal'+process.processId)" >
        {{ showText ? $t("Management.Seals.SealPrint"):"" }}
        <feather-icon
        icon="AwardIcon"
        :size="iconSize"
        v-b-tooltip.hover.top="$t('Management.Seals.SealPrint')"
        />
        <b-modal
          :id="'seal-modal'+process.processId"
          centered
          no-close-on-backdrop
          no-close-on-esc
          no-enforce-focus
          class="modal-dialog modal-dialog-centered"
        >
          <template #modal-title>
            {{ $t("Global.Select", {subject: $t('Management.Seals.SealPrintCount')}) }}
          </template>
          <template>
            {{ $t('Management.Processes.SealPrintSelection') }}
            <div class="from-to-container">
                <b-form-group :label="$t('Management.Seals.Print.From')">
                <b-form-input
                    id="from"
                    v-model="from"
                    :disabled="!$can($acl.action.Update, $acl.subjects.Processes)"
                    autocomplete="off"
                    type="number"
                    step="1"
                    min="1"
                />
            </b-form-group>
            <b-form-group :label="$t('Management.Seals.Print.To')">
                <b-form-input
                    id="to"
                    v-model="to"
                    :disabled="!$can($acl.action.Update, $acl.subjects.Processes)"
                    autocomplete="off"
                    type="number"
                    step="1"
                    min="1"
                />
            </b-form-group>
            </div>

          </template>
          <template #modal-footer>
            <div class="buttons-container d-flex">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="$bvModal.hide('seal-modal'+process.processId); print(count)"
              >
                {{ $t("Global.Accept") }}
              </b-button>
      
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-secondary"
                @click="$bvModal.hide('seal-modal'+process.processId)"
              >
                {{ $t("Global.Retreat") }}
              </b-button>
            </div>
          </template>
        </b-modal>
    </div>
</template>
<script>
import { jsPDF } from "jspdf";
import { ProcessTypesEnum, SortTypesEnum } from '@/data/enums';
import autoTable from 'jspdf-autotable'
import { BFormInput, BButton, BModal, BFormGroup } from "bootstrap-vue";

export default {
    components:{BButton, BFormGroup, BModal, BFormInput},
    props:{
        process: {
            type: Object,
            required: true,
        },
        showText: {
            type: Boolean,
            required: true
        },
        iconSize: {
            type: String,
            required: true
        }
    },
    data: () => ({
        ProcessTypesEnum,
        SortTypesEnum,
        count: 1,
        from: 1,
        to: 1
    }),

    methods: {
        async print(){
            console.log(this.process);
            const translationsRoot = "Management.Seals.Print";
            const doc = new jsPDF({unit: "mm", format: [98, 151], orientation: "landscape"} );
            const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
            const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
            const center = pageWidth / 2;

            let german = true;
            let tableAreas = [];
            let areas = [];

            for (let index = 0; index < this.process.areas.length; index++) {
                const area = this.process.areas[index];                
                if(area.country.short !== "DE"){
                    german = false;
                }
                if(areas.findIndex(ar => ar === area.name) === -1){
                    if(area.country.short !== "DE" && area.country.name !== area.name){
                        areas.push([`${area.country.short} - ${area.name}`]);
                    } else{
                        areas.push([area.name]);
                    }
                }
            }
            
            for (let index = 0; index < areas.length && index < 12; index++) {
                const area = areas[index];

                if(this.process.areas[index + 2]){
                    tableAreas.push([`${areas[index]} / ${areas[index+1]} / ${areas[index+2]}`]);
                    index+=2;
                }
                else if(this.process.areas[index + 1]){
                    tableAreas.push([`${areas[index]} / ${areas[index+1]}`]);
                    index++;
                } else{
                    tableAreas.push([`${areas[index]}`]);
                }
            }

            let tableSorts = [];
            if(this.process.sorts.length <= 3) {
                for (let index = 0; index < this.process.sorts.length; index++) {
                    const sort = this.process.sorts[index];
                    tableSorts.push([sort.name])
                }
            } else {
                for (let index = 0; index < this.process.sorts.length && index < 12; index++) {
                    const sort = this.process.sorts[index];
                    
                    if(this.process.sorts[index + 1]){
                        tableSorts.push([`${this.process.sorts[index].name} / ${this.process.sorts[index + 1].name}`]);
                        index++;
                    } else {
                        tableSorts.push([sort.name])
                    }
                }   
            }
            
            
            for (this.from; this.from <= this.to; this.from++) {

                doc.setFont("Times", "normal")
                doc.setFontSize(14);
                doc.text(this.$tc(`${translationsRoot}.Area`, 1), 10, 30);
                doc.text(this.$tc(`${translationsRoot}.Area`, 2), 10, 35);
                let sortHeight = 47 + tableAreas.length * 2;
                doc.text(this.$t(`${translationsRoot}.Sort`), 10, 45 + tableAreas.length);
                doc.text(this.$t(`${translationsRoot}.Bezug`), 10, 75);
                doc.text(this.$t(`${translationsRoot}.Harvest`),80, 75);

                doc.text(this.$t(`${translationsRoot}.Code`), 10, 82.5);
                doc.text(this.$t(`${translationsRoot}.Number`), 10, 90);
 
                doc.setFont("Times", "bold")

                doc.setFontSize(16);
                doc.text(`${this.from}`, center, 90);
                doc.text(`${this.process.harvestYear}` , 95, 75);
                doc.text(`${this.process.processId}` , 47, 75);
                doc.setFontSize(14);
                doc.text(this.$t(`${translationsRoot}.VA`), center, 18, "center");

                autoTable(doc, {
                    margin: { left: 30 },
                    startY: 26,
                    body: tableAreas,
                    theme:"plain",
                    columnStyles: { 0: { fontSize: 11 }, 1: { fontSize: 11 } },
                    cellWidth: 10,
                    styles: {
                        cellPadding: {top: 0, bottom: 0}
                    },
                });

                autoTable(doc, {
                    margin: { left: 30, right:53 },
                    startY: sortHeight-7,
                    body: tableSorts,
                    theme:"plain",
                    columnStyles: { 0: { fontSize: 11 }, 1: { fontSize: 11 } },
                    cellWidth: 10,
                    styles: {
                        cellPadding: {top: 0, bottom: 0}
                    },
                });




                doc.setFontSize(22);
                if(german){
                    doc.text(this.$tc(`${translationsRoot}.Header`, 1) + " " + this.$tc(`${translationsRoot}.Header`, 2), center, 10, "center");
                } else{
                    doc.text(this.$tc(`${translationsRoot}.Header`, 2), center, 10, "center");
                }
                if(this.from + 1 <= this.to){
                    doc.addPage();
                }

            }
            window.open(doc.output('bloburl'), '_blank'); 
            this.from = 1;
            this.to = 1;
        },

    }
}
</script>
<stlye lang="scss">
    .from-to-container {
        margin-top: 1rem;
        display: flex;
        justify-content: space-between;
    }
    .buttons-container{
        gap:1rem;
    }
</stlye>